import api from "../../api/services/axiosService";
import { DOCTOR_TATVA, MY_TATVA } from "../../envConstants";
import { getDecryptedData } from "../../utils/cryptoHelper";

const baseUrl: any = { customBaseUrl: DOCTOR_TATVA };
const myTBaseUrl: any = {
  customBaseUrl: MY_TATVA,
  isMyTatva: true,
};

export const fetchEarnings = async function (doctorId: number, payload: any) {
  let res = {
    data: {},
  };
  try {
    res = await api.post(`/api/v1/rewards/${doctorId}`, payload, baseUrl);
  } catch (e) {
    console.error("Error while sending otp: ", e);
  }
  return res?.data;
};

export const fetchPurchaseHistory = async function (
  doctorId: number,
  payload: any
) {
  let res = {
    data: {},
  };
  try {
    res = await api.post(
      `/api/v1/rewards/purchase-history/${doctorId}`,
      payload,
      baseUrl
    );
  } catch (e) {
    console.error("Error while sending otp: ", e);
  }
  return res?.data;
};

export const fetchMonetaryTrend = async function (
  doctorId: number,
  payload: any
) {
  let res = {
    data: [],
  };
  try {
    res = await api.post(
      `/api/v1/rewards/monatary-trend/${doctorId}`,
      payload,
      baseUrl
    );
  } catch (e) {
    console.error("Error while sending otp: ", e);
  }
  return res?.data;
};

export const fetchReferredPatientCount = async function (b2cId: any) {
  let res: any = {
    data: {},
  };
  try {
    res = await api.get(
      `/api/v8/doctor/referred_patients_count?b2cId=${b2cId}`,
      myTBaseUrl
    );
    res = JSON.parse(getDecryptedData(res?.data));
  } catch (e) {
    console.error("Error while fetching reffered patient count : ", e);
  }
  return res?.data;
};
